<!-- Advance search div STARTS -->
<div *ngIf="activeAdvanceSearch" class="padT16">
  <form [formGroup]="candidateSearchForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-3" *ngIf="showField('candidateId')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="Candidate ID" formControlName="candidateId" />
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('firstName')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="First Name" formControlName="firstName" />
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('middleName')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="Middle Name" formControlName="middleName" />
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('lastName')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="Last Name" formControlName="lastName" />
        </mat-form-field>
      </div>

      <div class="col-3" *ngIf="showField('dob')">
        <mat-form-field class="custom-form-field">
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="Date of birth"
            (click)="picker.open()"
            formControlName="dob"
            [max]="todayDate"
          />
          <mat-icon matSuffix style="cursor: pointer" (click)="picker.open()">
            <img src="assets/images/icons/default_icons/icon-calendar.png" alt="calendar" />
          </mat-icon>
          <mat-datepicker #picker touchUi> </mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('email')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="Email" formControlName="email" />
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('mobileNo')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="Mobile no." formControlName="mobileNo" />
          <mat-error *ngIf="candidateSearchForm.controls['mobileNo'].invalid">
            Please enter valid Mobile No.
          </mat-error>
        </mat-form-field>
      </div>
      <!-- <div class="col-3" *ngIf = "showField('pan')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="PAN" formControlName="pan">
        </mat-form-field>
      </div> -->
      <!-- <div class="col-3" *ngIf = "showField('school')">
        <mat-form-field class="custom-form-field">
            <input type="text" matInput placeholder="School" [matAutocomplete]="auto" [formControl]="dmyFrmCtrlScl"
              (ngModelChange)="onTypeInstitute($event)"   #stickSchoolDropdown (focusout)="outFocusSchool()">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setValueInForm($event.option.value,'school')" name = "inputCityDropdown">
              <div id="selectLocation">
                <mat-option *ngFor="let inst of selectedInstituteList; let index = index" [value]="inst.instituteName" >
                  <span id= "inputCityItem-{{index}}" [matTooltip]=setValueInTooltip(inst.instituteName)>{{inst.instituteName}}</span>
                </mat-option>
              </div>
            </mat-autocomplete>
          </mat-form-field>
      </div> -->
      <div class="col-3" *ngIf="showField('college')">
        <mat-form-field class="custom-form-field">
          <input
            type="text"
            matInput
            placeholder="College"
            [matAutocomplete]="auto"
            [formControl]="dmyFrmCtrlClg"
            (ngModelChange)="onTypeCollege($event)"
            #stickCollegeDropdown
            (focusout)="outFocusCollege()"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="addCollege($event.option.value)"
            name="inputCityDropdown"
          >
            <div id="selectLocation">
              <mat-option *ngFor="let inst of selectedCollegeList; let index = index" [value]="inst.instituteName">
                <span id="inputCityItem-{{ index }}" [matTooltip]="setValueInTooltip(inst.instituteName)">{{
                  inst.instituteName
                }}</span>
              </mat-option>
            </div>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('currentCompany')">
        <mat-form-field class="custom-form-field">
          <input
            type="text"
            matInput
            placeholder="Company"
            [matAutocomplete]="auto"
            formControlName="currentCompany"
            (ngModelChange)="onTypeCurrentCompany($event)"
            #stickCurComDropdown
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="addCurComp($event.option.value)"
            name="inputCityDropdown"
          >
            <div id="selectLocation">
              <mat-option
                *ngFor="let company of selectedCurrentCompany; let index = index"
                [value]="company.organizationName"
              >
                <span id="inputCityItem-{{ index }}" [matTooltip]="setValueInTooltip(company.organizationName)">{{
                  company.organizationName
                }}</span>
              </mat-option>
            </div>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('primarySkill')">
        <mat-form-field class="custom-form-field">
          <input
            type="text"
            matInput
            placeholder="Primary Skill"
            [matAutocomplete]="auto"
            [formControl]="dmyFrmCtrlPrmSkl"
            (ngModelChange)="onTypegetPrimarySkill($event)"
            id="skill"
            #stickPrimarySkill
            (focusout)="outFocusPrimarySkill()"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addPrimarySkill($event.option.value)">
            <div id="selectSkill">
              <mat-option
                *ngFor="let skill of selectedPrimarykills; let index = index"
                [value]="skill.skill_name"
                id="skillValue-{{ index }}"
              >
                <span [matTooltip]="setValueInTooltip(skill.skill_name)">{{ skill.skill_name }}</span>
              </mat-option>
            </div>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('secondarySkill')">
        <mat-form-field class="custom-form-field">
          <input
            type="text"
            matInput
            placeholder="Secondary Skill"
            [matAutocomplete]="auto"
            [formControl]="dmyFrmCtrlSecSkl"
            (ngModelChange)="onTypegetSecondarySkill($event)"
            id="skillSec"
            #stickSecondarySkill
            (focusout)="outFocusSecondarySkill()"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addSecondarySkill($event.option.value)">
            <div id="selectSkill">
              <mat-option
                *ngFor="let skill of selectedSecondarykills; let index = index"
                [value]="skill.skill_name"
                id="skillValue-{{ index }}"
              >
                <span [matTooltip]="setValueInTooltip(skill.skill_name)">{{ skill.skill_name }}</span>
              </mat-option>
            </div>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('experience')">
        <mat-form-field class="custom-form-field">
          <input matInput placeholder="Experience" type="number" [min]="0" formControlName="experience" />
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="showField('location')">
        <mat-form-field class="custom-form-field">
          <input
            type="text"
            matInput
            placeholder="Location"
            [matAutocomplete]="auto"
            [formControl]="dmyFrmCtrlLoc"
            (ngModelChange)="onTypeLocation($event)"
            name="eventCityInput"
            #stickEventLocation
            (focusout)="outFocusLocation()"
          />
          <mat-autocomplete #auto="matAutocomplete" name="inputCityDropdown">
            <div id="selectLocation">
              <mat-option
                *ngFor="let city of selectedLocationList; let index = index"
                [value]="city.city_state_country"
                (onSelectionChange)="addLocation(city.city_state_country)"
              >
                <span id="inputCityItem-{{ index }}" [matTooltip]="setValueInTooltip(city.city_state_country)">{{
                  city.city_state_country
                }}</span>
              </mat-option>
            </div>
          </mat-autocomplete>
          <!-- <mat-autocomplete #autoCities="matAutocomplete" (optionSelected)="selected($event)" id= "inputCandidateCity">
              <div id="selectCandidateLocation">
                <mat-option *ngFor="let city of cities;let index = index" [value]="city.city_state_country">
                  <span id= "candiateCityList-{{index}}">{{city.city_state_country}}</span>
                </mat-option>
              </div>
            </mat-autocomplete> -->
        </mat-form-field>
      </div>
      <div class="col-3" *ngIf="!showAllFields">
        <span class="col-1">
          <button class="marT18" mat-flat-button class="primary-btn" (click)="allFilter()">All Filters</button>
        </span>
      </div>
    </div>

    <span class="marT8" *ngIf="showAllFields">
      <span class="col-1" style="margin-left: -16px">
        <button mat-flat-button class="primary-btn" type="submit">Apply</button>
      </span>
      <span class="pad16">
        <button mat-flat-button class="secondary-btn" type="button" (click)="cancel()">Cancel</button>
      </span>
    </span>
  </form>
</div>
<!-- Advance search div ENDS -->

<div id="tableDiv_op" *ngIf="showTableData">
  <div id="DivStatusError_op" *ngIf="fetchStatus === 'error' || fetchStatus === 'none'" class="customCard nomarT">
    <div id="DivNodata_op" class="col-4 offset-4 marTB8 noData">
      <h5 id="DivHfive_op" class="H5Header marL16 marT32 center">
        <strong id="DivStrong_op" name="nodata" *ngIf="fetchStatus === 'none'">No data available</strong>
        <strong id="DivStrong_op_servererror" name="nodata" *ngIf="fetchStatus === 'error'"
          >Technical error occured! Try after sometime</strong
        >
      </h5>
    </div>
  </div>
  <div id="StatusDone_op" *ngIf="fetchStatus === 'done'" class="row marT16">
    <div class="col-12 marB16 btn-download">
      <app-excel-download
        [dataSource]="dataSource.data"
        [fileName]="'candidateList'"
        [columnNames]="column_download"
      ></app-excel-download>
    </div>
    <div id="StatusDoneCol_op" class="col-12">
      <table
        id="DoneTable_op"
        aria-describedby="display search table"
        mat-table
        [dataSource]="dataSource"
        multiTemplateDataRows
        aria-describedby="mydesc"
      >
        <!-- Position Column -->
        <ng-container id="Conatiner_op" matColumnDef="candidateId">
          <th id="DoneTH_op" mat-header-cell *matHeaderCellDef id="candidateId" class="GreylighterBg text-center">
            CandidateID
          </th>
          <td
            id="DTD{{ element.primaryEmail }}"
            mat-cell
            style="cursor: pointer"
            class="active-txt"
            [ngClass]="{ 'active-btn': selectedCandidateId === element.candidateId }"
            *matCellDef="let element"
            (click)="selectCandidate(element)"
          >
            {{ element.candidateId }}
          </td>
        </ng-container>

        <ng-container id="fullName_op" matColumnDef="fullName">
          <th id="fullNameTH_op" mat-header-cell *matHeaderCellDef id="candidateName" class="GreylighterBg text-center">
            Candidate Name
          </th>
          <td id="fNTD{{ element.fullName }}" mat-cell *matCellDef="let element">{{ element.fullName }}</td>
        </ng-container>

        <ng-container id="Email_op" matColumnDef="primaryEmail">
          <th id="EmailTH_op" mat-header-cell *matHeaderCellDef id="emailId" class="GreylighterBg text-center">
            Email Address
          </th>
          <td id="ETD{{ element.primaryEmail }}" mat-cell *matCellDef="let element">{{ element.primaryEmail }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container id="Dob_op" matColumnDef="dob">
          <th id="DobTH_op" mat-header-cell *matHeaderCellDef id="dob" class="GreylighterBg text-center">
            Date of Birth
          </th>
          <td id="Dob{{ element.primaryEmail }}" mat-cell *matCellDef="let element">
            {{ element.dob | date: 'MMM d, y' }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container id="Phone_op" matColumnDef="cellPhone">
          <th id="PhoneTH_op" mat-header-cell *matHeaderCellDef id="phNo" class="GreylighterBg text-center">
            Personal Number
          </th>
          <td id="PTD{{ element.primaryEmail }}_op" mat-cell *matCellDef="let element">{{ element.cellPhone }}</td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container id="Company_op" matColumnDef="currentCompany">
          <th id="CompanyTH_op" mat-header-cell *matHeaderCellDef id="lastEmployer" class="GreylighterBg text-center">
            Last Employer
          </th>
          <td id="cm{{ element.currentCompany }}" mat-cell *matCellDef="let element">{{ element.currentCompany }}</td>
        </ng-container>
        <ng-container *ngIf="companyHiringType1 == '1'" id="duplicateCheck_btn" matColumnDef="duplicateCheck">
          <th id="btnHeading" mat-header-cell *matHeaderCellDef id="duplicateCheck" class="GreylighterBg text-center">
            Duplicate PAN Check
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-raised-button class="primary-btn bg-color" (click)="duplicateChck(element.candidateId)">
              Check
            </button>
          </td>
        </ng-container>

        <ng-container id="Icon_op" matColumnDef="icon">
          <th id="IconTH_op" mat-header-cell *matHeaderCellDef id="icon" class="GreylighterBg text-center"></th>
          <td id="IconTD{{ row.primaryEmail }}" mat-cell *matCellDef="let row" style="cursor: pointer">
            <a (click)="openAttachment(row)"
              ><img
                name="attachImgColumn{{ row.candidateId }}"
                src="assets/images/icons/default_icons/icon-attachment.png"
                alt="icon-attachment"
                class="pointer"
                width="20px"
                height="20px"
            /></a>
          </td>
        </ng-container>

        <tr id="IcnTRStcky_op" mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
        <tr id="IconDisp_op" mat-row *matRowDef="let row; columns: displayedColumns1"></tr>
      </table>
    </div>
  </div>
  <div id="Pagtn_op" class="pagination-container">
    <!-- <span *ngIf = "dataSource.data.length">
  <button name="goToButton" mat-stroked-button style="height: 30px; margin-top: 16px; margin-right: 16px;"
  (click)="goToPage()">Go to</button>
<mat-form-field style="width: 30px;">
  <input name="page" matInput placeholder="" [(ngModel)]="pageNumber">
</mat-form-field>
</span> -->

    <mat-paginator
      id="Paginator_op"
      style="background: #fafafa"
      [hidden]="!dataSource.data.length"
      showFirstLastButtons
      [pageSize]="11"
    >
    </mat-paginator>
  </div>
</div>
<div *ngIf="showTable || showMssg" class="overlay"></div>
<div *ngIf="showTable || showMssg" class="centered-div" id="centeredDiv">
  <div class="float-right">
    <img
      src="assets/images/icons/white_icons/icon-close.png"
      alt="Close"
      (click)="onClose()"
      [ngStyle]="{ 'text-decoration': 'none', cursor: 'pointer', color: '#FFFFFF', 'height:': '22px' }"
      id="btn-close"
    />
  </div>
  <div style="background-color: #8626c3; height: 60px">
    <h4 class="headingDesign">Duplicate PAN Check</h4>
  </div>
  <div *ngIf="showTable" class="col-12 marB16 btn-download">
    <app-excel-download
      [dataSource]="tableSource.data"
      [fileName]="'DuplicatePanList_' + (selectedCandidateId1?.toString() || '')"
      [columnNames]="columnDefs"
    ></app-excel-download>
  </div>
  <mat-tab-group *ngIf="showTable">
    <mat-tab label="{{ dummy?.message }}">
      <mat-card-content>
        <div class="container-fluid padT32">
          <div class="example-table-container" style="max-height: 294px; overflow: auto">
            <table mat-table [dataSource]="tableSource" aria-describedby="mytabledesc" aria-describedby="mytabledesc">
              <ng-container [matColumnDef]="column" *ngFor="let column of columnDefs">
                <th class="sticky" mat-header-cell *matHeaderCellDef>{{ column }}</th>
                <td mat-cell *matCellDef="let element">
                  <span>{{ element[column] || '-' }}</span>
                </td>
              </ng-container>

              <tr class="stickyDesign" mat-header-row *matHeaderRowDef="columnDefs"></tr>
              <tr mat-row *matRowDef="let row; columns: columnDefs"></tr>
            </table>
          </div>
        </div>
      </mat-card-content>
    </mat-tab>
  </mat-tab-group>
  <div *ngIf="!showTable" class="container-fluid">
    <h6 class="H6Header">
      <div name="showMssg">{{ dummy?.message }}</div>
    </h6>
  </div>
</div>
